import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['switchable']

  onSwitch(event) {
    this.switchableTargets.forEach(switchable => {
      const switchValues = JSON.parse(switchable.dataset.switchValues)
      let key = event.currentTarget.value

      if (event.type == 'click') {
        const currentValueKey = switchable.dataset.currentValue
        key = Object.keys(switchValues).find(switchKey => switchKey !== currentValueKey)
        switchable.dataset.currentValue = key
      }

      switchable.innerHTML = switchValues[key]
    })
  }
}
